export const JUNO_CDN_PROPOSALS_ERROR_CANNOT_SUBMIT = 'juno.cdn.proposals.error.cannot_submit';
export const JUNO_CDN_PROPOSALS_ERROR_CANNOT_SUBMIT_INVALID_STATUS =
  'juno.cdn.proposals.error.cannot_submit_invalid_status';

export const JUNO_CDN_PROPOSALS_ERROR_CANNOT_REJECT = 'juno.cdn.proposals.error.cannot_reject';
export const JUNO_CDN_PROPOSALS_ERROR_CANNOT_REJECT_INVALID_STATUS =
  'juno.cdn.proposals.error.cannot_reject_invalid_status';

export const JUNO_CDN_PROPOSALS_ERROR_CANNOT_COMMIT = 'juno.cdn.proposals.error.cannot_commit';
export const JUNO_CDN_PROPOSALS_ERROR_CANNOT_COMMIT_INVALID_STATUS =
  'juno.cdn.proposals.error.cannot_commit_invalid_status';

export const JUNO_CDN_PROPOSALS_ERROR_INVALID_HASH = 'juno.cdn.proposals.error.invalid_hash';

export const JUNO_CDN_PROPOSALS_ERROR_UNKNOWN_TYPE = 'juno.cdn.proposals.error.unknown_type';

export const JUNO_CDN_PROPOSALS_ERROR_NOT_CONTENT_CHUNKS_AT_INDEX =
  'juno.cdn.proposals.error.no_content_chunks_at_index';

export const JUNO_CDN_PROPOSALS_ERROR_EMPTY_ASSETS = 'juno.cdn.proposals.error.empty_assets';
export const JUNO_CDN_PROPOSALS_ERROR_CANNOT_DELETE_ASSETS =
  'juno.cdn.proposals.error.cannot_delete_assets';
export const JUNO_CDN_PROPOSALS_ERROR_CANNOT_DELETE_ASSETS_INVALID_STATUS =
  'juno.cdn.proposals.error.cannot_delete_assets_invalid_status';

export const JUNO_CDN_PROPOSALS_ERROR_NEXT_ID_CONVERT = 'juno.cdn.proposals.error.next_id_convert';
export const JUNO_CDN_PROPOSALS_ERROR_NEXT_ID_OVERFLOW =
  'juno.cdn.proposals.error.next_id_overflow';

export const JUNO_CDN_STORAGE_ERROR_CANNOT_INSERT_ASSET_UNKNOWN_REFERENCE_ID =
  'juno.cdn.storage.error.cannot_insert_asset_unknown_reference_id';
export const JUNO_CDN_STORAGE_ERROR_CANNOT_GET_ASSET_UNKNOWN_REFERENCE_ID =
  'juno.cdn.storage.error.cannot_get_asset_unknown_reference_id';
export const JUNO_CDN_STORAGE_ERROR_CANNOT_INSERT_ASSET_ENCODING_UNKNOWN_REFERENCE_ID =
  'juno.cdn.storage.error.cannot_insert_asset_encoding_unknown_reference_id';

export const JUNO_CDN_STORAGE_ERROR_NO_PROPOSAL_FOUND = 'juno.cdn.storage.error.no_proposal_found';

export const JUNO_CDN_STORAGE_ERROR_INVALID_RELEASES_PATH =
  'juno.cdn.storage.error.invalid_releases_path';

export const JUNO_CDN_STORAGE_ERROR_MISSING_RELEASES_DESCRIPTION =
  'juno.cdn.storage.error.missing_releases_description';

export const JUNO_CDN_STORAGE_ERROR_INVALID_RELEASES_DESCRIPTION =
  'juno.cdn.storage.error.invalid_releases_description';

export const JUNO_CDN_STORAGE_ERROR_INVALID_COLLECTION =
  'juno.cdn.storage.error.invalid_collection';
